import {
  executeNotificationReader,
  useNotificationReaderRefused,
} from '@/hooks/queries/notification-reader-cache'
import { useClientPortalDirectorySession } from '@/hooks/queries/useClientPortalDirectorySession'
import {
  portalDirectoryApi,
  portalDirectoryKeys,
} from '@/modules/client-portal/directory.api'
import { isPortalMetadataUnavailable } from '@/modules/client-portal/metadata.api'
import { useQuery, useQueryClient } from '@tanstack/react-query'

export function useMyEntities() {
  const session = useClientPortalDirectorySession()
  const client = useQueryClient()
  const key = portalDirectoryKeys.list(session.key)
  const query = useQuery({
    queryKey: key,
    queryFn: ({ signal }) =>
      executeNotificationReader(
        client,
        key,
        session,
        signal,
        portalDirectoryApi.read,
      ),
    enabled: session.enabled,
    staleTime: 300000,
    gcTime: 60000,
    retry: (failures, error) =>
      !isPortalMetadataUnavailable(error) && failures < 2,
  })
  const refused = useNotificationReaderRefused(client, key)
  const unavailable = !session.enabled || query.isError || refused
  return {
    ...query,
    unavailable,
    isError: unavailable,
    data: unavailable ? undefined : query.data,
    async refetch(...args: Parameters<typeof query.refetch>) {
      session.assertCurrent()
      const result = await query.refetch(...args)
      session.assertCurrent()
      return result
    },
  }
}
